import axios, { AxiosRequestConfig } from 'axios';
import { KEY_ACCESS_TOKEN, X_API_KEY } from '../../../Helpers/constant';
import { config } from '../../../config/environment';
import storage from '../../../Utils/storageService';

const axiosInstance = axios.create({ baseURL: config.apiBaseUrl });
// const axiosInstance = axios.create({ baseURL: 'http://localhost:4000/' });

axiosInstance.interceptors.request.use(async (req: AxiosRequestConfig) => {
    try {
      const token = await storage.getItem(KEY_ACCESS_TOKEN);
      req.headers = req.headers || {};
      req.headers['x-api-key'] = X_API_KEY;
      if (token) {
        req.headers['Authorization'] = `${token}`;
      }
      return req;
    } catch (error) {
      console.error('Error retrieving token:', error);
      return req;
    }
  });

  axiosInstance.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      if (error.response?.status === 401) {
        storage.clear();
        window.location.href = '/login';
        // if (originalRequest._retry) {
        //   console.error('Token refresh failed. Redirecting to login...');
        //   storage.clear();
        //   window.location.href = '/login';
        //   return Promise.reject(error); // Prevent retry
        // }

        // originalRequest._retry = true;
        // try {
        //   const refreshtoken = await storage.get(KEY_REFRESH_TOKEN);
        //   if (!refreshtoken) {
        //     throw new Error("No refresh token found.");
        //   }

        //   const newTokens = await generateNewToken(refreshtoken);
        //   if (newTokens) {
        //     const newAccessToken = newTokens.accessToken?.token;
        //     await storage.set(KEY_ACCESS_TOKEN, newAccessToken);
        //     await storage.set(KEY_REFRESH_TOKEN, newTokens?.refreshToken?.token);

        //     originalRequest.headers['Authorization'] = `${newAccessToken}`;
        //     return axiosInstance(originalRequest);
        //   }
        // } catch (err) {
        //   console.error('Token refresh failed:', err);
        //   storage.clear();
        //   window.location.href = '/login';
        //   return Promise.reject(err);
        // }
      }
      return Promise.reject(error);
    }
  );

export const eventsCreation = async (payload: any) => {
  try {
    const path = `/v1/event/eventmanagement`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

// export const getEventsData = async () => {
//   try {
//     const path = 'v1/event/eventmanagement';
//     const res: any = await axiosInstance.get(path);
//     return res && res.data ? res.data : res;
//   } catch (error) {
//     return error;
//   }
// };

export const createSession = async (payload: any) => {
  try {
    const path = '/v1/event/session';
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const updateSession = async (payload: any) => {
  try {
    const path = '/v1/event/session';
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getSessionDetails = async (eventId: string) => {
  try {
    const path = `/v1/event/sessions?eventId=${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getregisteredevents = async (eventId: string) => {
  try {
    const path = `/v1/event/getregisteredevents?contactid=${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    console.error('Error fetching registered events:', error);
    return { data: null, error: error };
  }
};

export const deleteSpeaker = async (id: any) => {
  try {
    const path = '/v1/event/delete-speaker';
    const res: any = await axiosInstance.post(path, {
      data: id,
    });
    return res && res.data ? res.data : res;
  } catch (err) {
    return err;
  }
};

export const updateSessionFee = async (payload: any) => {
  try {
    const path = `/v1/event/session`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deleteSession = async (payload: any) => {
  try {
    const path = `/v1/event/sessions`;
    const res: any = await axiosInstance.delete(path, { data: payload });
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const eventRegistration = async (payload: any) => {
  try {
    const path = `/v1/event/bookingregistration`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEventRegistration = async (eventId: string, applicantId: string) => {
  try {
    const path = `/v1/event/bookingregistration/?eventId=${eventId}&contactId=${applicantId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelEventRegistration = async (payload: any) => {
  try {
    const path = `/v1/event/bookingregistration`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
